import { useEffect, useState } from "react"
import "./MyProfile.scss"
import UserDetails, {
  UserDetailsProps,
} from "../../components/ui/UserDetails/UserDetails.component"
import { getUserAsync, selectUserData } from "../../redux/slices/authSlice"
import { CreditCardList, UserData } from "../../types/userTypes"
import { Typography } from "@mui/material"
import {
  hideModal,
  ModalTypes,
  selectActiveModal,
} from "../../redux/slices/modalSlice"
import { useAppDispatch, useAppSelector } from "../../redux/hooks"
import { PaymentDetails } from "../../components/ui/PaymentDetails/PaymentDetails.component"
import GeneralSettings from "../../components/ui/GeneralSettings/GeneralSettings.component"
import { RegisteredDrivers } from "../../components/ui/RegisteredDrivers/RegisteredDrivers.component"
import AddDriverModal from "../../components/Modals/AddDriverModal/AddDriverModal.component"
import AddDriverDetailsModal from "../../components/Modals/AddDriverDetailsModal/AddDriverDetailsModal.component"
import {
  getDriversAsync,
  selectDriversList,
} from "../../redux/slices/driverSlice"
import { useTranslationLabel } from "../../hooks/useTranslationLabel"
import AddCreditCardModal from "../../components/Modals/AddCreditCardModal/AddCreditCardModal.component"
import ChangePasswordModal from "../../components/Modals/ChangePasswordModal/ChangePasswordModal.component"
import { Driver } from "../../types/driverTypes"
import { useUserType } from "../../hooks/useUserType"
import { parseQuery } from "../../utils/utils"
import CredoraxClass from "../../redux/api/CredoraxClass"
import { showAlert } from "../../redux/slices/alertSlice"
import { useNavigate } from "react-router-dom"
import { ROUTES } from "../../config/routes.const"
import DisconnectModal from "../../components/Modals/DisconnectModal/DisconnectModal.component"
import ChangePinCodeModal from "../../components/Modals/ChangePinCodeModal/ChangePinCodeModal"
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL

const MyProfile = () => {
  const userData: UserData | null = useAppSelector(selectUserData)
  const driversList: Driver[] = useAppSelector(selectDriversList)
  const dispatch = useAppDispatch()
  const userType = useUserType()
  const navigate = useNavigate()

  const [userDetails, setUserDetails] = useState<UserDetailsProps>()
  const [creditCardList, setCreditCardList] = useState<CreditCardList[]>([])
  const [selectedDriver, setSelectedDriver] = useState<Driver>();
  const { firstName, lastName } = userData?.personal || {}
  const activeModal: ModalTypes | null = useAppSelector(selectActiveModal)

  const { USER_TYPE_PRIVATE, USER_TYPE_BUSINESS, REQ_SUCCESS, REQ_FAILD } = useTranslationLabel()

  const customer = {
    customerToken: localStorage.getItem("x-Customer") || "",
    loginToken: localStorage.getItem("x-Token") || "",
  }

  const Credorax = new CredoraxClass(
    customer,
    "https://ppskey-int.credorax.com/keypayment/rest/v2/store",
    apiBaseUrl + "/",
  )

  const handleCloseModal = () => {
    dispatch(getDriversAsync())
    dispatch(hideModal())
  }

  useEffect(() => {
    if (userData) {
      if (userType === "client") {
        dispatch(getDriversAsync())
      }
      const { address, city, phoneNumber, email } = userData.personal
      const cardList: CreditCardList[] = userData.accountDetails?.creditCardList

      setCreditCardList(cardList || [])
      setUserDetails({
        street: address,
        city: city,
        phone: phoneNumber,
        email,
      })
    }
  }, [userData, userType, dispatch])

  useEffect(() => {
    const query = parseQuery(window.location.href)
    let z2 = query.z2

    if (z2 === 0 || z2 === "0") {
      let CcAuthNum = query.z50
      let CCCompanyTypeId = query.b2
      let ccToken = query.g1
      Credorax.updateUserWithNewCreditCard({
        ccToken,
        CcAuthNum,
        CCCompanyTypeId,
        accountId: userData?.accountDetails?.accountId,
      }).then((data) => {
        if (data === true) {
          dispatch(getUserAsync())
          dispatch(
            showAlert({
              text: REQ_SUCCESS,
              type: "success",
            }),
          )
        } else {
          dispatch(
            showAlert({
              text: REQ_FAILD,
              type: "error",
            }),
          )
        }
      })
    } else {
      if ((z2 !== 0 && z2 !== undefined) || (z2 !== "0" && z2 !== undefined)) {
        dispatch(
          showAlert({
            text: "Faild",
            type: "error",
          }),
        )
      }
    }
    navigate(ROUTES.PROFILE)
  }, [userData])
  console.log("userData", userData?.personal?.customerTypeId)
  return (
    <div className="profile-container column">
      <Typography className="name" variant="h3">
        {firstName + " " + lastName}
      </Typography>
      <Typography className="membership" variant="h5">
        {userData?.personal?.customerTypeId ===  1 ? USER_TYPE_BUSINESS : USER_TYPE_PRIVATE }
      </Typography>
      {userDetails && (
        <UserDetails
          street={userDetails.street}
          city={userDetails.city}
          phone={userDetails.phone}
          email={userDetails.email}
          displayPassowrdUpdate={
            userData?.personal?.convertPhoneLoginActionTypeId !== 1
          }
        />
      )}
      {userType === "client" && (
        <PaymentDetails creditCardList={creditCardList} />
      )}
      {userType === "client" && <RegisteredDrivers driversList={driversList} setSelectedDriver={setSelectedDriver}/>}
      <GeneralSettings />

      {true && (
        <>
          <ChangePasswordModal
            open={activeModal === ModalTypes.CHANGE_PASSWORD_MODAL}
            handleClose={handleCloseModal}
          />

          {/* WIP */}
          <ChangePinCodeModal
            open={activeModal === ModalTypes.CHANGE_PIN_CODE_MODAL}
            handleClose={handleCloseModal}
          />
          <AddDriverModal
            open={activeModal === ModalTypes.ADD_DRIVER_MODAL}
            handleClose={handleCloseModal}
          />
          <AddDriverDetailsModal
            open={activeModal === ModalTypes.ADD_DRIVER_DETAILS_MODAL}
            handleClose={handleCloseModal}
          />
          <AddCreditCardModal
            open={activeModal === ModalTypes.ADD_CARD_MODAL}
            handleClose={handleCloseModal}
          />
          <DisconnectModal
            open={activeModal === ModalTypes.DISCONNECT_MODAL}
            handleClose={()=>{
              handleCloseModal()
            }}
            driverId={selectedDriver?.id}
            driverStatusId={selectedDriver?.driverStatusId}
          />
        </>
      )}
    </div>
  )
}

export default MyProfile
